import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import Moment from 'moment';
import MatButton from '@mui/material/Button';
import MUIDataTable from "mui-datatables";

import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";

// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import ReportHeader from "Routes/reportTemplate/header";
import ReportFooter from "Routes/reportTemplate/footer";
import ReportBGImage from "Routes/reportTemplate/watermark";

import {
   getMskReport,
   fetchPostureList,
   getMskReportDate
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';


class mskreport extends Component {
   
    constructor(props) {
      
        super(props);
        this.state = {
            student: '',
            quarter:'',
            seldate:'',
            maindiv:false,
            viewdiv:true,
            repeatHeaders:true,
            succdiv:false,
            errordiv:false,
        };      
         
      
         this.onBackSection = this.onBackSection.bind(this);  
         this.backSection = this.backSection.bind(this);  
    }

    UNSAFE_componentWillMount() {
        const studid=localStorage.getItem('user_id');
        this.props.fetchPostureList();
        this.props.getMskReportDate(studid);
	}

    onBackSection() {
		this.setState({ adddiv:false,
         editdiv:false,
         viewdiv:true });
	}

    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');        
        this.setState({ seldate:date });      
    }

    selectquarter(evt){
        var selstudent=evt.value;
        if(selstudent!=''){
            this.setState({ student : selstudent});
            this.props.getMskReportDate(selstudent).then((data) => {   
                this.setState({ viewdiv : true});
            });
           
        }
    }
    
    addHandleReport(assmntval){
        var student = assmntval.user_id;
        var quarter = assmntval.quarter;
        var seldate = assmntval.assessment_date;
        this.props.getMskReport(student, quarter, seldate).then((data) => {   
            
            if(data==1){
                this.setState({ 
                    maindiv:false,
                    viewdiv:false,
                    errordiv:false,
                    succdiv:true });    
            }else{
                this.setState({ 
                    succdiv:false,
                    errordiv:true });    
            }

        });
        
    }

    calculate_age = (dob1) => {
        var today = new Date();
        var birthDate = new Date(dob1); 
        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
        {
            age_now--;
        }
        return age_now;
    }

   
    
    backSection(){
        this.setState({ 
            maindiv:true,
            viewdiv:true,
            errordiv:false,
            succdiv:false });    
    }

    setPercentage = (percentage) => {
        return Math.round(600 / 100) * percentage;
    }

    render() {
      const { match, reportmskresponse, reportDates, postureabbreivation, loading } = this.props;

    const options = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "No" },
        { name: "name", label: "Name" },
        { name: "assessment", label: "Assessment No" },
        { name: "date", label: "Date" },
        { name: "action", label: "Action" }
    ];

    const tabledata=reportDates.map((assmntval,idx) => {  

            const ebtn=<MatButton variant="contained" color="error" className="btn-icon btn-google mr-15 mb-10 text-white" onClick={ ()=>this.addHandleReport(assmntval)}> <i className="zmdi zmdi-file-text"></i> Report</MatButton>;
            return {
            no:idx+1,
            name: assmntval.student,
            assessment: assmntval.quarter,
            date: assmntval.cdate,
            action: ebtn
            }
    });
        
        const checkage= reportmskresponse.uud_dob;
        const studentage=this.calculate_age(checkage);   
        
        const formatDate = Moment(reportmskresponse.rdate).format('DD-MM-YYYY');
        
      const styles = {
        table: {
            border: "1px solid black",
            borderColor:"black",
            borderStyle:"solid",
            fontFamily: "Arial",            
            zIndex:"100"
        },
        tabletrtd: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            whiteSpace: "pre-line",
            wordWrap: "break-word",            
            textAlign: "center"
        },
        tabletleft: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            whiteSpace: "pre-line",
            wordWrap: "break-word"
            
        },
        tabletleft20: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            whiteSpace: "pre-line",
            wordWrap: "break-word",            
            width:"20%"
        },
        tabletleft30: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            width:"30%"
            
        },
        tabtrtd30: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            width:"30%",            
            fontWeight:"bold"
        },
        tabtrtd40: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            width:"40%",            
            fontWeight:"bold"
        },
        tabtrtd20: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            width:"20%",            
            fontWeight:"bold"
        },
        tabtrtd15: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            width:"15%",            
            fontWeight:"bold"
        },
        tabtrtd12: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            width:"15%"
        },
        tabtrtd10: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            width:"10%",            
            textAlign : "center"
        },
        tabtrtd7:{
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            width:"7%",            
            textAlign : "center"
        },
        tabtrtd15: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            width:"17%",            
            textAlign : "left",
            fontWeight:"bold"
        },
        tablehead: {
            borderWidth: "1px",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            border:"1px soild black",
            borderColor:"black",
            borderStyle:'solid',
            backgroundColor:"#ccc",
            textAlign: "center",
            fontWeight:"bold"
        },
        tablehead30: {
            borderWidth: "1px",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            border:"1px soild black",
            borderColor:"black",
            borderStyle:'solid',
            backgroundColor:"#ccc",
            textAlign: "center",
            fontWeight:"bold",
            width:"30%"
        },
        tableheadblue: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            backgroundColor:"#ccc",
            textAlign: "center",
            fontWeight:"bold"
        },
        tableheadblue20: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            backgroundColor:"#ccc",
            width:"20%",
            textAlign: "center",
            fontWeight:"bold"
        },
        tableheadblue30: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            backgroundColor:"#ccc",
            width:"30%",
            textAlign: "center",
            fontWeight:"bold"
        },
        tableheadblue10: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            backgroundColor:"#ccc",
            width:"10%",
            textAlign: "center",
            fontWeight:"bold"
        },
        tableheadblue15: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            backgroundColor:"#ccc",
            width:"17%",
            textAlign: "center",
            fontWeight:"bold"
        },
        tableheadblue12: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            backgroundColor:"#ccc",
            width:"15%",
            textAlign: "center",
            fontWeight:"bold"
        },
        tableheadblue7:{
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            backgroundColor:"#ccc",
            width:"7%",
            textAlign: "center",
            fontWeight:"bold"
        },
        tableheadblue40: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            backgroundColor:"#ccc",
            width:"40%",
            textAlign: "center",
            fontWeight:"bold"
        },
        mainheading:{
            padding: "10px 20px 20px 20px",
            backgroundColor: "rgb(204 204 204)",
            border:"1px solid black",
            marginBottom: "20px",
            marginTop: "20px",
            width: "650px",
            display: "block",
            fontWeight:"bold",
            position:"relative"
        },
        secondheading :{
            fontWeight: "bold",
            marginBottom: "30px",
            marginTop:"20px",
            position:"relative"
        },
        subheading:{
            padding: "10px",
            backgroundColor: "#a4f3f3cc",
            border:"1px soild black",
            marginBottom:"10px",
            paddingRight:"30px",
            position:"relative"
        },
        errmessage:{
            textAlign:"center",
            color:"red"
        },
        rctcontent:{
            marginTop:"30px",
            borderRadius: "5px",
            boxShadow: "0 1px 15px 1px rgba(69, 65, 78, 0.08)",
            border: "none",
            transition: "all 0.4s ease-in-out 0s",
            marginBottom: "24px",
            padding:"0px 20px 10px 20px",
            zIndex:"1"

        }
      };

    
       return (
          
            <div className="row">   
               
                {this.state.viewdiv && 
                    <div className="col-sm-12 col-md-12">
                        <div className="col-md-8" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="Report List" fullBlock>
                            <MUIDataTable
                                data={tabledata}
                                columns={columns}
                                options={options} 
                            />   
                        </RctCollapsibleCard>
                        </div>
                    </div>  
                }  
                {this.state.succdiv &&
                    <div className="col-sm-12 col-md-8" style={{margin:"0 auto"}}>   
                        <div className="example-config">
                            

                            <button
                            className="mr-10 mb-10 btn btn-outline-warning float-right"
                            onClick={this.backSection}
                            >
                            Back
                            </button>
                        
                        </div>
                        
                        <RctCollapsibleCard fullBlock > 
                            <ReportHeader />
                            <div style={styles.rctcontent}>
                                <ReportBGImage  data={"50%"}/>
                                <div className="rct-block-content" style={{padding:"1.25rem 1.25rem"}}>
                                    <div className="row justify-content-center reportdiv">
                                        <h1 className="text-center" style={{marginTop:"20px", marginBottom:"20px"}}> SPORTS SCIENCE SCREENING REPORT </h1>
                                        <table className="table align-items-center table-flush" style={styles.table}>
                                            
                                            <tbody>
                                            <tr>
                                                <td className="tablehead30">
                                                    DATE 
                                                </td>
                                                <td style={styles.tabletleft20}>
                                                    {formatDate}
                                                </td>
                                                <td className="tablehead30">
                                                    ASSESSMENT NO
                                                </td>
                                                <td style={styles.tabletleft20}>
                                                    {reportmskresponse.quarter}
                                                </td>
                                            </tr>
                                            <tr>
                                                    <td style={styles.tabtrtd30}>
                                                        MSK ASSESSOR 
                                                    </td>
                                                    <td colSpan="3" style={styles.tabletleft}>
                                                    {reportmskresponse.mskassessor}
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td style={styles.tabtrtd30}>
                                                    S&C ASSESSOR
                                                    </td>
                                                    <td colSpan="3" style={styles.tabletleft}>
                                                    {reportmskresponse.scassessor}
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td colSpan="4" style={styles.tablehead}>
                                                    <div className="text-center" style={{fontWeight:"bold",fontSize:"14px"}}> PLAYER DETAILS</div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                <td style={styles.tabtrtd30} >NAME </td>
                                                <td colSpan="3" style={styles.tabletleft}> {reportmskresponse.uud_firstName} {reportmskresponse.uud_lastName} </td>
                                            </tr>
                                            <tr>
                                                <td style={styles.tabtrtd30}>AGE</td>
                                                <td colSpan="3" style={styles.tabletleft}> {studentage} </td>
                                            </tr>
                                            <tr>
                                                <td style={styles.tabtrtd30}>EMAIL ID</td>
                                                <td colSpan="3" style={styles.tabletleft}>  {reportmskresponse.uud_email} </td>
                                            </tr>
                                            <tr>
                                                <td style={styles.tabtrtd30}>CELL NO</td>
                                                <td colSpan="3" style={styles.tabletleft}>  {reportmskresponse.uud_phone} </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        
                                        <table className="table align-items-center table-flush" style={styles.table}>                                    
                                            <tbody>
                                                <tr>
                                                    <td style={styles.tabtrtd30}>
                                                        SKILL
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.mskskill}
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd30}>
                                                        MEDICAL HISTORY 
                                                    </td>
                                                    <td style={styles.tabletleft} >
                                                        {reportmskresponse.medicalhistory}
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd30}>
                                                        MEDICAL RECORD 
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.medicalrecord}
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd30}>
                                                        ALLERGIES
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {(reportmskresponse.allergies!=0) ? reportmskresponse.allergies : ''}
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd30}>
                                                    INJURY HISTORY
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.injuryhistory}
                                                    </td>                                                
                                                </tr>
                                            </tbody>    
                                        </table>
                                    </div>
                                </div>
                                <ReportFooter /> 
                            </div>
                        </RctCollapsibleCard>            

                        <RctCollapsibleCard fullBlock > 
                            <ReportHeader />
                            <div style={styles.rctcontent}>
                                <ReportBGImage data={"50%"}/> 
                                <div className="rct-block-content" style={{padding:"1.25rem 1.25rem"}}>
                                    <div className="row justify-content-center reportdiv">           
                                        <div className="page-break"></div>
                                        <div className="row clearfix">
                                        <span className="text-center" style={styles.mainheading}><h2 style={{fontWeight:"bold"}} >PART I - MUSCULOSKELETAL SCREENING REPORT </h2></span>  
                                        </div> 
                                        <div class="col-md-12 clearfix">
                                        <h3 className="text-center" style={styles.secondheading}> COMPONENT 1: POSTURE </h3>
                                        </div>
                                        <table className="table align-items-center table-flush" style={styles.table}>                                    
                                            <tbody>                                        
                                                <tr>
                                                    <td style={styles.tableheadblue20}>
                                                        Regions 
                                                    </td>
                                                    <td style={styles.tableheadblue30}>
                                                        IMPRESSION 
                                                    </td>
                                                    <td style={styles.tableheadblue}>
                                                        APPROACH 
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Head
                                                    </td>
                                                    <td style={styles.tabletleft30}>
                                                        {reportmskresponse.head}
                                                    </td> 
                                                    <td rowSpan="3" style={styles.tabletleft}>
                                                        {reportmskresponse.head_approach}
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Shoulders
                                                    </td>
                                                    <td style={styles.tabletleft30}>
                                                        {reportmskresponse.shoulders}
                                                    </td>                                         
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Thoracic Spine
                                                    </td>
                                                    <td style={styles.tabletleft30}>
                                                        {reportmskresponse.thoracic_spine}
                                                    </td>                                         
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Lumbar Spine
                                                    </td>
                                                    <td style={styles.tabletleft30}>
                                                        {reportmskresponse.lumbar_spine}
                                                    </td> 
                                                    <td rowSpan="2" style={styles.tabletleft}>
                                                        {reportmskresponse.spine_approach}
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                    Pelvis
                                                    </td>
                                                    <td style={styles.tabletleft30}>
                                                        {reportmskresponse.spine_pelvis}
                                                    </td>                                         
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Knee 
                                                    </td>
                                                    <td style={styles.tabletleft30}>
                                                        {reportmskresponse.knee}
                                                    </td> 
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.knee_approach}
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Feet
                                                    </td>
                                                    <td style={styles.tabletleft30}>
                                                        {reportmskresponse.feet}
                                                    </td>   
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.feet_approach}
                                                    </td>                                       
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Glenohumeral Rhythm
                                                    </td>
                                                    <td style={styles.tabletleft30}>
                                                        {reportmskresponse.glenohumeral_rhythm}
                                                    </td> 
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.glenohumeral_approach}
                                                    </td>                                                
                                                </tr>
                                            </tbody>    
                                        </table>
                                        <h3 className="text-center" style={styles.secondheading}> COMPONENT 2: SPINE </h3>
                                        <table className="table align-items-center table-flush" style={styles.table}>                                    
                                            <tbody>                                        
                                                <tr>
                                                    <td style={styles.tableheadblue20}>
                                                        Test 
                                                    </td>
                                                    <td style={styles.tableheadblue7} width={this.setPercentage(8)}>
                                                        Rt
                                                    </td> 
                                                    <td style={styles.tableheadblue7} width={this.setPercentage(8)}>
                                                        Lt 
                                                    </td>  
                                                    <td style={styles.tableheadblue10}>
                                                    Goal 
                                                    </td> 
                                                    <td style={styles.tableheadblue}>
                                                        IMPRESSION
                                                    </td> 
                                                    <td style={styles.tableheadblue}>
                                                        APPROACH 
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Combined Elevation Test
                                                    </td> 
                                                    <td colSpan="2" style={styles.tabtrtd10}>
                                                        {(reportmskresponse.combined_elevation!=0) ? reportmskresponse.combined_elevation : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.combined_elevation_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.combined_elevation_approach}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Trunk Forward Flexion
                                                    </td> 
                                                    <td colSpan="2" style={styles.tabtrtd10}>
                                                    {(reportmskresponse.trunk_forward_flexion!=0) ? reportmskresponse.trunk_forward_flexion : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center"> &#x2265;5 cm</div>
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.trunk_forward_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.trunk_forward_approach}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Trunk Extension
                                                    </td> 
                                                    <td colSpan="2" style={styles.tabtrtd10}>
                                                    {(reportmskresponse.trunk_extension!=0) ? reportmskresponse.trunk_extension : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center"> &#x2265;3 cm</div>
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.trunk_extension_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.trunk_extension_approach}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Trunk Side Flexion
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.trunk_side_flexion_rt!=0) ? reportmskresponse.trunk_side_flexion_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.trunk_side_flexion_lt!=0) ? reportmskresponse.trunk_side_flexion_lt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center">Difference &#x2264;3cm </div>
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.trunk_side_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.trunk_side_approach}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table> 
                                    </div>
                                </div>
                                <ReportFooter /> 
                            </div>
                        </RctCollapsibleCard>                


                        <RctCollapsibleCard fullBlock > 
                            <ReportHeader />
                            <div style={styles.rctcontent}>
                                <ReportBGImage data={"60%"}/> 
                                <div className="rct-block-content" style={{padding:"1.25rem 1.25rem"}}>
                                    <div className="row justify-content-center reportdiv">  
                                        <h3 className="text-center" style={styles.secondheading}> COMPONENT 3: UPPER LIMB </h3>
                                        <table className="table align-items-center table-flush" style={styles.table}>                                    
                                            <tbody>                                       
                                                <tr>
                                                    <td style={styles.tableheadblue20}>
                                                        Test 
                                                    </td>
                                                    <td style={styles.tableheadblue7}>
                                                        Rt 
                                                    </td> 
                                                    <td style={styles.tableheadblue7}>
                                                        Lt
                                                    </td>  
                                                    <td style={styles.tableheadblue10}>
                                                        Goal
                                                    </td> 
                                                    <td style={styles.tableheadblue}>
                                                        IMPRESSION
                                                    </td> 
                                                    <td style={styles.tableheadblue}>
                                                        APPROACH 
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Shoulder Internal Rotation
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.shoulders_internal_rotation_rt!=0) ? reportmskresponse.shoulders_internal_rotation_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.shoulders_internal_rotation_lt!=0) ? reportmskresponse.shoulders_internal_rotation_lt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center">&#x2265;90&#176;</div>
                                                    </td>
                                                    <td rowSpan="2" style={styles.tabletleft}>
                                                        {reportmskresponse.shoulders_internal_impression}
                                                    </td>
                                                    <td rowSpan="2" style={styles.tabletleft}>
                                                        {reportmskresponse.shoulders_internal_approach}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Shoulder External Rotation
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.shoulders_external_rotation_rt!=0) ? reportmskresponse.shoulders_external_rotation_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.shoulders_external_rotation_lt!=0) ? reportmskresponse.shoulders_external_rotation_lt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center"> &#x2265;90&#176;</div>
                                                    </td>                                            
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Infraspinatus Strength
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.gird_erg_rt!=0) ? reportmskresponse.gird_erg_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.gird_erg_lt!=0) ? reportmskresponse.gird_erg_lt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center">5 MMT</div>
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.gird_erg_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.gird_erg_approach}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td rowSpan="2" style={styles.tabtrtd20}>
                                                        Kibler’s 1
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.kibler_one_rt_one!=0) ? reportmskresponse.kibler_one_rt_one : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.kibler_one_lt_one!=0) ? reportmskresponse.kibler_one_lt_one : ''}
                                                    </td>
                                                    <td rowSpan="2" style={styles.tabtrtd10}>
                                                        <div className="text-center">&#x2264;1.5 cm</div>
                                                    </td>
                                                    <td rowSpan="6" style={styles.tabletleft}>
                                                        {reportmskresponse.kibler_one_impression}
                                                    </td>
                                                    <td rowSpan="6" style={styles.tabletleft}>
                                                        {reportmskresponse.kibler_one_approach}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.kibler_one_rt_two!=0) ? reportmskresponse.kibler_one_rt_two : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.kibler_one_lt_two!=0) ? reportmskresponse.kibler_one_lt_two : ''}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td rowSpan="2" style={styles.tabtrtd20}>
                                                        Kibler’s 2
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.kibler_two_rt_one!=0) ? reportmskresponse.kibler_two_rt_one : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.kibler_two_lt_one!=0) ? reportmskresponse.kibler_two_lt_one : ''}
                                                    </td>
                                                    <td rowSpan="2" style={styles.tabtrtd10}>
                                                        <div className="text-center">&#x2264;1.5 cm</div>
                                                    </td>                                            
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.kibler_two_rt_two!=0) ? reportmskresponse.kibler_two_rt_two : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.kibler_two_lt_two!=0) ? reportmskresponse.kibler_two_lt_two : ''}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td rowSpan="2" style={styles.tabtrtd20}>
                                                        Kibler’s 3
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.kibler_three_rt_one!=0) ? reportmskresponse.kibler_three_rt_one : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.kibler_three_lt_one!=0) ? reportmskresponse.kibler_three_lt_one : ''}
                                                    </td>
                                                    <td rowSpan="2" style={styles.tabtrtd10}>
                                                        <div className="text-center">&#x2264;1.5 cm</div>
                                                    </td>                                            
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.kibler_three_rt_two!=0) ? reportmskresponse.kibler_three_rt_two : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.kibler_three_lt_two!=0) ? reportmskresponse.kibler_three_lt_two : ''}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Lat Muscle Length
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.lat_muscle_length_rt!=0) ? reportmskresponse.lat_muscle_length_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.lat_muscle_length_lt!=0) ? reportmskresponse.lat_muscle_length_lt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center">&#x2265;170&#176;</div>
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.lat_muscle_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.lat_muscle_approach}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                            <h3 className="text-center" style={styles.secondheading}> COMPONENT 4: LOWER LIMB </h3>
                                        <table className="table align-items-center table-flush" style={styles.table}>  
                                            <tbody>
                                                
                                                <tr>
                                                    <td style={styles.tableheadblue20}>
                                                        Test 
                                                    </td>
                                                    <td style={styles.tableheadblue7}>
                                                        Rt
                                                    </td> 
                                                    <td style={styles.tableheadblue7}>
                                                        Lt
                                                    </td>  
                                                    <td style={styles.tableheadblue10}>
                                                    Goal
                                                    </td> 
                                                    <td style={styles.tableheadblue}>
                                                        IMPRESSION 
                                                    </td> 
                                                    <td style={styles.tableheadblue}>
                                                        APPROACH 
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Leg Length
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.leg_length_rt!=0) ? reportmskresponse.leg_length_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.leg_length_lt!=0) ? reportmskresponse.leg_length_lt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center">Difference &#x2264;3cm</div>
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.leg_length_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.leg_length_approach}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Hamstring Length
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.hamstring_length_rt!=0) ? reportmskresponse.hamstring_length_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.hamstring_length_lt!=0) ? reportmskresponse.hamstring_length_lt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center">&#x2265;160&#176;</div>
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.hamstring_length_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.hamstring_length_approach}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Iliopsoas Muscle Length 
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                        {reportmskresponse.iliopsoas_muscle_length_rt }
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                    {reportmskresponse.iliopsoas_muscle_length_lt}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center">&#x2264;5&#176;</div>
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.iliopsoas_muscle_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.iliopsoas_muscle_approach}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Quad Muscle Length
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.quad_muscle_rt!=0) ? reportmskresponse.quad_muscle_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.quad_muscle_lt!=0) ? reportmskresponse.quad_muscle_lt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center">&#x2265;80&#176;</div>
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.quad_musclelength_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.quad_musclelength_approach}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Hip Internal Rotation
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.hip_internal_rotation_rt!=0) ? reportmskresponse.hip_internal_rotation_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.hip_internal_rotation_lt!=0) ? reportmskresponse.hip_internal_rotation_lt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center">&#x2265;30&#176; </div>
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.hip_internal_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.hip_internal_approach}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Hip External Rotation
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.hip_external_rotation_rt!=0) ? reportmskresponse.hip_external_rotation_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.hip_external_rotation_lt!=0) ? reportmskresponse.hip_external_rotation_lt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center">&#x2265;45&#176;</div>
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.hip_external_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.hip_external_approach}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Piriformis Ms Length 
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                        {reportmskresponse.piriformis_ms_length_rt }
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                        {reportmskresponse.piriformis_ms_length_lt}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center"> &#x3c;10&#176; </div>
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.piriformis_ms_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.piriformis_ms_approach}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        DF Lunge Test
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.df_lunge_test_rt!=0) ? reportmskresponse.df_lunge_test_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.df_lunge_test_lt!=0) ? reportmskresponse.df_lunge_test_lt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center"> &#x2265;10 cm </div>
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.df_lunge_test_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.df_lunge_test_approach}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Single Leg Eyes Open
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                    {(reportmskresponse.single_leg_eye_open_rt!=0) ? reportmskresponse.single_leg_eye_open_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.single_leg_eye_open_lt!=0) ? reportmskresponse.single_leg_eye_open_lt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        <div className="text-center">{'> 60 Sec'}</div>
                                                    </td>
                                                    <td style={styles.tabletleft} rowSpan="2">
                                                        {reportmskresponse.single_leg_impression}
                                                    </td>
                                                    <td style={styles.tabletleft} rowSpan="2">
                                                        {reportmskresponse.single_leg_approach}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Single Leg Eyes Closed
                                                    </td> 
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.single_leg_eye_close_rt!=0) ? reportmskresponse.single_leg_eye_close_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd7}>
                                                        {(reportmskresponse.single_leg_eye_close_lt!=0) ? reportmskresponse.single_leg_eye_close_lt : ''}
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        <div className="text-center"> {'> 60 Sec'}</div>
                                                    </td>                                            
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <ReportFooter /> 
                            </div>
                        </RctCollapsibleCard>                

                        <RctCollapsibleCard fullBlock > 
                            <ReportHeader />
                            <div style={styles.rctcontent}>
                                <ReportBGImage data={"60%"}/> 
                                <div className="rct-block-content" style={{padding:"1.25rem 1.25rem"}}>
                                    <div className="row justify-content-center reportdiv">                 
                                        <h3 className="text-center" style={styles.secondheading}> COMPONENT 5: GLUTE  AND CORE STABILITY </h3>
                                        <div class="col-md-12 clearfix">
                                            <h3 className="text-center" style={styles.secondheading}>Glute Stability Test</h3> 
                                        </div> 
                                        <table className="table align-items-center table-flush" style={styles.table}>                                    
                                            <tbody>                                         
                                                <tr>
                                                    <td style={styles.tableheadblue20}>
                                                        Test
                                                    </td>
                                                    <td style={styles.tableheadblue10}>
                                                        Rt
                                                    </td> 
                                                    <td style={styles.tableheadblue10}>
                                                        Lt 
                                                    </td> 
                                                    <td style={styles.tableheadblue}>
                                                        IMPRESSION
                                                    </td> 
                                                    <td style={styles.tableheadblue}>
                                                        APPROACH 
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Level 1: &#x2264; 60 sec
                                                    </td> 
                                                    <td style={styles.tabtrtd10}>
                                                    {(reportmskresponse.glute_level_one_rt!=0) ? reportmskresponse.glute_level_one_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                    {(reportmskresponse.glute_level_one_lt!=0) ? reportmskresponse.glute_level_one_lt : ''}
                                                    </td>                                            
                                                    <td style={styles.tabletleft} rowSpan="3">
                                                        {reportmskresponse.glute_impression}
                                                    </td>
                                                    <td style={styles.tabletleft} rowSpan="3">
                                                        {reportmskresponse.glute_level_approach}
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Level 2: = 60-90 sec
                                                    </td> 
                                                    <td style={styles.tabtrtd10}>
                                                    {(reportmskresponse.glute_level_two_rt!=0) ? reportmskresponse.glute_level_two_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                    {(reportmskresponse.glute_level_two_lt!=0) ? reportmskresponse.glute_level_two_lt : ''}
                                                    </td>   
                                                </tr> 
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Level 3: &#x2265;90 sec
                                                    </td> 
                                                    <td style={styles.tabtrtd10}>
                                                    {(reportmskresponse.glute_level_three_rt!=0) ? reportmskresponse.glute_level_three_rt : ''}
                                                    </td>
                                                    <td style={styles.tabtrtd10}>
                                                        {(reportmskresponse.glute_level_three_lt!=0) ? reportmskresponse.glute_level_three_lt : ''}
                                                    </td>   
                                                </tr> 
                                            </tbody>
                                        </table>   
                                        <h3 className="text-center" style={styles.secondheading}> Transverse Abdominal Muscle  Control in Supine</h3> 
                                        <table className="table align-items-center table-flush" style={styles.table}>                                    
                                            <tbody>                                        
                                                <tr>                                            
                                                    <td colSpan="2" style={styles.tableheadblue}>
                                                        IMPRESSION AND APPROACH
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Level 1 – Crook lying
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                    {(reportmskresponse.tacontrol_level_one!=0) ? reportmskresponse.tacontrol_level_one : ''}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Level 2 – Single Leg Heel Slide
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                    {(reportmskresponse.tacontrol_level_two!=0) ? reportmskresponse.tacontrol_level_two : ''}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Level 3 – Single Leg Knee Extension
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                    {(reportmskresponse.tacontrol_level_three!=0) ? reportmskresponse.tacontrol_level_three : ''}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Level 4 – Double Leg Heel Slide
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                    {(reportmskresponse.tacontrol_level_four!=0) ? reportmskresponse.tacontrol_level_four : ''}
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Level 5 – Double Leg Knee Extension
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                    {(reportmskresponse.tacontrol_level_five!=0) ? reportmskresponse.tacontrol_level_five : ''}
                                                    </td>
                                                </tr>    
                                            </tbody>
                                        </table> 

                                        <div className="page-break"></div>
                                        <h3 className="text-center" style={styles.secondheading}> COMPONENT 6 : SPECIAL TEST</h3> 
                                        <table className="table align-items-center table-flush" style={styles.table}>                                    
                                            <tbody>
                                                
                                                <tr>
                                                    <td style={styles.tableheadblue20}>
                                                        Test
                                                    </td>
                                                    <td style={styles.tableheadblue10}>
                                                        Rt
                                                    </td>
                                                    <td style={styles.tableheadblue10}>
                                                        Lt
                                                    </td>
                                                    <td style={styles.tableheadblue10}>
                                                        Goal
                                                    </td>
                                                    <td style={styles.tableheadblue}>
                                                        IMPRESSION
                                                    </td>
                                                    <td style={styles.tableheadblue}>
                                                        APPROACH
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        HK Impingement Test
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.hk_impingement_test_rt}
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.hk_impingement_test_lt} 
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        Neg
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.hk_impingement_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.hk_impingement_approach}
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Empty Can Test
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.empty_can_test_rt}
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.empty_can_test_lt} 
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        Neg
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.empty_can_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.empty_can_approach}
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Load And Shift Test
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.full_can_test_rt}
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.full_can_test_lt} 
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        Neg
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.full_can_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.full_can_approach}
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                    Spine Quadrant Test
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.spine_quadrant_test_rt}
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.spine_quadrant_test_lt} 
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        Neg
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.spine_quadrant_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.spine_quadrant_approach}
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                    Trendelenburg Sign
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.trendelenberg_sign_rt}
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.trendelenberg_sign_lt} 
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        Neg
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.trendelenberg_sign_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.trendelenberg_sign_approach}
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Hip Quadrant Test
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.hip_quadrant_test_rt}
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.hip_quadrant_test_lt} 
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        Neg
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.hip_quadrant_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.hip_quadrant_approach}
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Post. Impingement Test
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.post_impingement_test_rt}
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.post_impingement_test_lt} 
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        Neg
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.post_impingement_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.post_impingement_approach}
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td style={styles.tabtrtd20}>
                                                        Sulcus Sign.(Shoulder)
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.infraspinatus_strength_rt}
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {reportmskresponse.infraspinatus_strength_lt} 
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        Neg
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.infraspinatus_strength_impression}
                                                    </td>
                                                    <td style={styles.tabletleft}>
                                                        {reportmskresponse.infraspinatus_strength_approach}
                                                    </td>
                                                </tr> 
                                            </tbody>
                                        </table> 
                                    </div>
                                </div>
                                <ReportFooter /> 
                            </div>
                        </RctCollapsibleCard>     

                            <RctCollapsibleCard fullBlock > 
                                <ReportHeader />
                                <div style={styles.rctcontent}>
                                    <ReportBGImage data={"60%"}/> 
                                    <div className="rct-block-content" style={{padding:"1.25rem 1.25rem"}}>
                                        <div className="row justify-content-center reportdiv">     
                                        <div className="page-break"></div>
                                        <table className="table align-items-center table-flush" style={styles.table}>                                    
                                            <tbody>
                                                <tr>
                                                    <td style={styles.tableheadblue}>
                                                    OVERALL IMPRESSION 
                                                    </td>                                               
                                                </tr>
                                                
                                                {reportmskresponse.overall_impression_one!=null ?
                                                (
                                                    <tr>
                                                        <td style={styles.tabletleft}>
                                                        {reportmskresponse.overall_impression_one} 
                                                        </td>                                               
                                                    </tr>
                                                ) : '' }

                                                {reportmskresponse.overall_impression_two!=null ?
                                                (
                                                    <tr>
                                                        <td style={styles.tabletleft}>
                                                        {reportmskresponse.overall_impression_two} 
                                                        </td>                                               
                                                    </tr>
                                                ) : '' }

                                                {reportmskresponse.overall_impression_three!=null ?
                                                (
                                                    <tr>
                                                        <td style={styles.tabletleft}>
                                                        {reportmskresponse.overall_impression_three} 
                                                        </td>                                               
                                                    </tr>
                                                ) : '' }

                                                {reportmskresponse.overall_impression_four!=null ?
                                                (
                                                    <tr>
                                                        <td style={styles.tabletleft}>
                                                        {reportmskresponse.overall_impression_four} 
                                                        </td>                                               
                                                    </tr>
                                                ) : '' }

                                                {reportmskresponse.overall_impression_five!=null ?
                                                (<tr>
                                                        <td style={styles.tabletleft}>
                                                        {reportmskresponse.overall_impression_five} 
                                                        </td>                                               
                                                    </tr>
                                                ) : '' }
                                                {reportmskresponse.overall_impression_six!=null ?
                                                (<tr>
                                                        <td style={styles.tabletleft}>
                                                        {reportmskresponse.overall_impression_six} 
                                                        </td>                                               
                                                    </tr>
                                                ) : '' }
                                                {reportmskresponse.overall_impression_seven!=null ?
                                                (<tr>
                                                        <td style={styles.tabletleft}>
                                                        {reportmskresponse.overall_impression_seven}
                                                        </td>                                               
                                                    </tr>
                                                ) : '' }
                                                {reportmskresponse.overall_impression_eight!=null ?
                                                (<tr>
                                                        <td style={styles.tabletleft}>
                                                        {reportmskresponse.overall_impression_eight} 
                                                        </td>                                               
                                                    </tr>
                                                ) : '' }
                                                
                                            </tbody>
                                        </table>  

                                        <table className="table align-items-center table-flush" style={styles.table}>
                                                <thead className="thead-light">  
                                                    <td style={styles.tableheadblue}>
                                                    ABBREVIATIONS
                                                    </td>
                                                </thead>
                                                <tbody>
                                                    {postureabbreivation.map((abbrval) => (
                                                        
                                                        <tr>
                                                            <td style={styles.tabletleft}>{abbrval.pa_name}</td>
                                                        </tr>                                                
                                                    ))} 
                                                                                                                                    
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <ReportFooter /> 
                                </div>
                            </RctCollapsibleCard>                
                                  
                            {reportmskresponse.stcndid!=null ? 
                            (
                            <>    
                            <RctCollapsibleCard fullBlock > 
                                <ReportHeader />
                                <div style={styles.rctcontent}>
                                    <ReportBGImage  data={"60%"}/>
                                    <div className="rct-block-content" style={{padding:"1.25rem 1.25rem"}}>
                                        <div className="row justify-content-center reportdiv">                                         
                                            <div className="row">
                                            <span className="text-center" style={styles.mainheading}> <h2 style={{fontWeight:"bold"}} > PART II - STRENGTH & CONDITIONING ASSESSMENT </h2> </span>  
                                            </div>  
                                            
                                            <div class="col-md-12 clearfix">
                                                <h3 className="text-center" style={styles.secondheading}> ANTHROPOMETRIC ASSESSMENT </h3>
                                            </div>
                                            <table className="table align-items-center table-flush" style={styles.table}>
                                                <tbody>
                                                    <tr>
                                                    <td style={styles.tableheadblue}>Height (cm)</td>
                                                    <td style={styles.tableheadblue}>Weight (kg)</td>
                                                    <td style={styles.tableheadblue}>BMI (kg/m<sup style={{top: "-5px"}}>2</sup>)</td>
                                                    <td style={styles.tableheadblue}>Waist (cm)</td>
                                                    <td style={styles.tableheadblue}>Hip (cm)</td>
                                                    <td style={styles.tableheadblue}>Waist to Hip Ratio</td>
                                                    </tr>
                                                    <tr>
                                                    <td style={styles.tabletrtd}> {(reportmskresponse.scheight!=0) ? reportmskresponse.scheight : ''}</td>
                                                    <td style={styles.tabletrtd}> {(reportmskresponse.scweight!=0) ? reportmskresponse.scweight : ''}</td>
                                                    <td style={styles.tabletrtd}> {(reportmskresponse.scbmi!=0) ? reportmskresponse.scbmi : ''}</td>
                                                    <td style={styles.tabletrtd}> {(reportmskresponse.scwaist!=0) ? reportmskresponse.scwaist : ''}</td>
                                                    <td style={styles.tabletrtd}> {(reportmskresponse.schip!=0) ? reportmskresponse.schip : ''}</td>
                                                    <td style={styles.tabletrtd}> {(reportmskresponse.scwhratio!=0) ? reportmskresponse.scwhratio : ''}</td>
                                                    </tr>
                                                </tbody>                                
                                            </table> 

                                            <table className="table align-items-center table-flush" style={styles.table}>
                                                <tbody>
                                                    <tr>
                                                    <td style={styles.tableheadblue}>UA Right (cm)</td>
                                                    <td style={styles.tableheadblue}>UA Left (cm)</td>
                                                    <td style={styles.tableheadblue}>Mid Thigh Right (cm)</td>
                                                    <td style={styles.tableheadblue}>Mid Thigh Left (cm)</td>
                                                    <td style={styles.tableheadblue}>Mid Calf Right (cm)</td>
                                                    <td style={styles.tableheadblue}>Mid Calf Left (cm)</td>
                                                    </tr>
                                                    <tr>
                                                    <td style={styles.tabletrtd}> {(reportmskresponse.scuaright!=0) ? reportmskresponse.scuaright : ''}</td>
                                                    <td style={styles.tabletrtd}> {(reportmskresponse.scualeft!=0) ? reportmskresponse.scualeft : ''}</td>
                                                    <td style={styles.tabletrtd}> {(reportmskresponse.scmidthighright!=0) ? reportmskresponse.scmidthighright : ''}</td>
                                                    <td style={styles.tabletrtd}> {(reportmskresponse.scmidthighleft!=0) ? reportmskresponse.scmidthighleft : ''}</td>
                                                    <td style={styles.tabletrtd}> {(reportmskresponse.scmidcalfright!=0) ? reportmskresponse.scmidcalfright : ''}</td>
                                                    <td style={styles.tabletrtd}> {(reportmskresponse.scmidcalfleft!=0) ? reportmskresponse.scmidcalfleft : ''}</td>
                                                    </tr>
                                                </tbody>                                
                                            </table> 

                                            <table className="table align-items-center table-flush" style={styles.table}>
                                                <tbody>
                                                    <tr>
                                                    <td style={styles.tableheadblue}>IMPRESSION</td>
                                                    <td style={styles.tableheadblue}>APPROACH</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tabletleft}> {reportmskresponse.sc_impression}</td>
                                                        <td style={styles.tabletleft}> {reportmskresponse.sc_approach}</td>
                                                    </tr>
                                                </tbody>
                                            </table>        
                                        
                                            <div className="row">
                                            <h3 className="text-center" style={styles.secondheading}> FUNCTIONAL MOVEMENT SCREENING </h3>
                                            </div>

                                            <table className="table align-items-center table-flush" style={styles.table}>
                                                <tbody>
                                                    <tr>
                                                    <td colSpan="2" style={styles.tableheadblue40}>Test </td>
                                                    <td style={styles.tableheadblue10}>Raw Score </td>
                                                    <td style={styles.tableheadblue10}>Final Score</td>
                                                    <td style={styles.tablehead}>Comments</td>
                                                    </tr>
                                                    <tr>
                                                    <td colSpan="2" style={styles.tabtrtd40}> Deep Squat </td>
                                                    <td style={styles.tabtrtd10}> {(reportmskresponse.deepsquat_rawscore!=0) ? reportmskresponse.deepsquat_rawscore : ''}</td>
                                                    <td style={styles.tabtrtd10}> {(reportmskresponse.deepsquat_finalscore!=0) ? reportmskresponse.deepsquat_finalscore : ''}</td>
                                                    <td style={styles.tabletleft}> {reportmskresponse.deepsquat_comments}</td>                                          
                                                    </tr>
                                                    <tr>
                                                    <td rowSpan="2" style={styles.tabtrtd30}> Hurdle Step </td>
                                                    <td style={styles.tabtrtd10}>R</td>
                                                    <td style={styles.tabtrtd10}> {(reportmskresponse.hurdlestep_r_rawscore!=0) ? reportmskresponse.hurdlestep_r_rawscore : ''}</td>
                                                    <td rowSpan="2" style={styles.tabtrtd10}> {(reportmskresponse.hurdlestep_r_finalscore!=0) ? reportmskresponse.hurdlestep_r_finalscore : ''}</td>
                                                    <td style={styles.tabletleft}> {reportmskresponse.hurdlestep_r_comments}</td>                                          
                                                    </tr>
                                                    <tr>
                                                    <td style={styles.tabtrtd10}>L</td>
                                                    <td style={styles.tabtrtd10}> {(reportmskresponse.hurdlestep_l_rawscore!=0) ? reportmskresponse.hurdlestep_l_rawscore : ''}</td>
                                                    <td style={styles.tabletleft}> {reportmskresponse.hurdlestep_l_commentsvv}</td>                                          
                                                    </tr>
                                                    <tr>
                                                    <td rowSpan="2" style={styles.tabtrtd30}> In-Line Lunge  </td>
                                                    <td style={styles.tabtrtd10}>R</td>
                                                    <td style={styles.tabtrtd10}> {(reportmskresponse.inlinelunge_r_rawscore!=0) ? reportmskresponse.inlinelunge_r_rawscore : ''}</td>
                                                    <td rowSpan="2" style={styles.tabtrtd10}> {(reportmskresponse.inlinelunge_r_finalscore!=0) ? reportmskresponse.inlinelunge_r_finalscore : ''}</td>
                                                    <td style={styles.tabletleft}> {reportmskresponse.inlinelunge_r_comments}</td>                                          
                                                    </tr>
                                                    <tr>
                                                    <td style={styles.tabtrtd10}>L</td>
                                                    <td style={styles.tabtrtd10}> {(reportmskresponse.inlinelunge_l_rawscore!=0) ? reportmskresponse.inlinelunge_l_rawscore : ''}</td>
                                                    <td style={styles.tabletleft}> {reportmskresponse.inlinelunge_l_comments}</td>                                          
                                                    </tr>
                                                    <tr>
                                                    <td rowSpan="2" style={styles.tabtrtd30}> Shoulder Mobility  </td>
                                                    <td style={styles.tabtrtd10}>R</td>
                                                    <td style={styles.tabtrtd10}> {(reportmskresponse.shouldermobility_r_rawscore!=0) ? reportmskresponse.shouldermobility_r_rawscore : ''}</td>
                                                    <td rowSpan="2" style={styles.tabtrtd10}> {(reportmskresponse.shouldermobility_r_finalscore!=0) ? reportmskresponse.shouldermobility_r_finalscore : ''}</td>
                                                    <td style={styles.tabletleft}> {reportmskresponse.shouldermobility_r_comments}</td>                                          
                                                    </tr>
                                                    <tr>
                                                    <td style={styles.tabletrtd}>L</td>
                                                    <td style={styles.tabtrtd10}> {(reportmskresponse.shouldermobility_l_rawscore!=0) ? reportmskresponse.shouldermobility_l_rawscore : ''}</td>
                                                    <td style={styles.tabletleft}> {reportmskresponse.shouldermobility_l_comments}</td>                                          
                                                    </tr>
                                                    <tr>
                                                    <td style={styles.tabtrtd30}> Shoulder Clearance Test</td>
                                                    <td colSpan="4" style={styles.tabletrtd}> {reportmskresponse.shoulderclearance_r_comments}</td>
                                                    </tr>
                                                    <tr>
                                                    <td rowSpan="2" style={styles.tabtrtd30}> Active Straight Leg Raise  </td>
                                                    <td style={styles.tabtrtd10}>R</td>
                                                    <td style={styles.tabtrtd10}> {(reportmskresponse.activestraightlegraise_r_rawscore!=0) ? reportmskresponse.activestraightlegraise_r_rawscore : ''}</td>
                                                    <td rowSpan="2" style={styles.tabtrtd10}> {(reportmskresponse.activestraightlegraise_r_finalscore!=0) ? reportmskresponse.activestraightlegraise_r_finalscore : ''}</td>
                                                    <td style={styles.tabletleft}> {reportmskresponse.activestraightlegraise_r_comments}</td>                                          
                                                    </tr>
                                                    <tr>
                                                    <td style={styles.tabletrtd}>L</td>
                                                    <td style={styles.tabtrtd10}> {(reportmskresponse.activestraightlegraise_l_rawscore!=0) ? reportmskresponse.activestraightlegraise_l_rawscore : ''}</td>
                                                    <td style={styles.tabletleft}> {reportmskresponse.activestraightlegraise_l_comments}</td>                                          
                                                    </tr>
                                                    <tr>
                                                    <td colSpan="2" style={styles.tabtrtd30}>Trunk Stability Push Up </td>
                                                    <td style={styles.tabtrtd10}> {(reportmskresponse.trunkstabilitypushup_rawscore!=0) ? reportmskresponse.trunkstabilitypushup_rawscore : ''}</td>
                                                    <td style={styles.tabtrtd10}> {(reportmskresponse.trunkstabilitypushup_finalscore!=0) ? reportmskresponse.trunkstabilitypushup_finalscore : ''}</td>
                                                    <td style={styles.tabletleft}> {reportmskresponse.trunkstabilitypushup_comments}</td>                                          
                                                    </tr>
                                                    <tr>
                                                    <td style={styles.tabtrtd30}> Press up Clearing Test</td>
                                                    <td colSpan="4" style={styles.tabletrtd}> {reportmskresponse.pressupclearing_comments}</td>
                                                    </tr>
                                                    <tr>
                                                    <td rowSpan="2" style={styles.tabtrtd30}> Rotary Stability </td>
                                                    <td style={styles.tabtrtd10}>R</td>
                                                    <td style={styles.tabtrtd10}> {(reportmskresponse.rotarystability_r_rawscore!=0) ? reportmskresponse.rotarystability_r_rawscore : ''}</td>
                                                    <td rowSpan="2" style={styles.tabtrtd10}> {(reportmskresponse.rotarystability_r_finalscore!=0) ? reportmskresponse.rotarystability_r_finalscore : ''}</td>
                                                    <td style={styles.tabletleft}> {reportmskresponse.rotarystability_r_comments}</td>                                          
                                                    </tr>
                                                    <tr>
                                                    <td style={styles.tabletrtd}>L</td>
                                                    <td style={styles.tabtrtd10}> {(reportmskresponse.rotarystability_l_rawscore!=0) ? reportmskresponse.rotarystability_l_rawscore : ''}</td>
                                                    <td style={styles.tabletleft}> {reportmskresponse.rotarystability_l_comments}</td>                                          
                                                    </tr>
                                                    <tr>
                                                    <td style={styles.tabtrtd30}> Posterior Rocking Clearing Test</td>
                                                    <td colSpan="4" style={styles.tabletrtd}> {reportmskresponse.posteriorrocking_comments}</td>
                                                    </tr>
                                                    <tr>
                                                    <td style={styles.tabtrtd30}> Total Score </td>
                                                    <td colSpan="4" style={styles.tabletrtd}> {reportmskresponse.totalscore_finalscore} </td>
                                                    </tr>
                                                </tbody>                                
                                            </table>

                                            <table className="table align-items-center table-flush" style={styles.table}>
                                                <tbody>
                                                    <tr>
                                                    <td style={styles.tablehead}>IMPRESSION</td>
                                                    <td style={styles.tablehead}>APPROACH</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tabletleft}> {reportmskresponse.functionalmovement_impression}</td>
                                                        <td style={styles.tabletleft}> {reportmskresponse.functionalmovement_approach}</td>
                                                    </tr>
                                                </tbody>
                                            </table> 
                                        
                                            <div className="row">
                                                <h3 className="text-center" style={styles.secondheading}> MOVEMENT PATTERN ASSESSMENT </h3>
                                            </div>

                                            <table className="table align-items-center table-flush" style={styles.table}>
                                                <tbody>
                                                    <tr>                                          
                                                    <td style={styles.tableheadblue20}>MOVEMENT </td>
                                                    <td style={styles.tableheadblue10}>SCORE</td>
                                                    <td style={styles.tablehead}>REMARKS</td>
                                                    </tr>
                                                    <tr>                                          
                                                    <td style={styles.tabtrtd20}>Box Jump </td>
                                                    <td style={styles.tabtrtd10}>{reportmskresponse.boxjump_score}</td>
                                                    <td style={styles.tabletleft}>{reportmskresponse.boxjump_remarks}</td>
                                                    </tr>
                                                    <tr>                                          
                                                    <td style={styles.tabtrtd20}>Single Leg Hop (R)  </td>
                                                    <td style={styles.tabtrtd10}>{reportmskresponse.singlerighthopright_score}</td>
                                                    <td style={styles.tabletleft}>{reportmskresponse.singlerighthopright_remarks}</td>
                                                    </tr>
                                                    <tr>                                          
                                                    <td style={styles.tabtrtd20}>Single Leg Hop (L) </td>
                                                    <td style={styles.tabtrtd10}>{reportmskresponse.singlerighthopleft_score}</td>
                                                    <td style={styles.tabletleft}>{reportmskresponse.singlerighthopleft_remarks}</td>
                                                    </tr>
                                                    <tr>                                          
                                                    <td style={styles.tabtrtd20}>Deadlift </td>
                                                    <td style={styles.tabtrtd10}>{reportmskresponse.deadlift_score}</td>
                                                    <td style={styles.tabletleft}>{reportmskresponse.deadlift_remarks}</td>
                                                    </tr>
                                                    <tr>                                          
                                                    <td style={styles.tabtrtd20}>Pull Up/Chin Up/Inverted Row </td>
                                                    <td style={styles.tabtrtd10}>{reportmskresponse.pullup_score}</td>
                                                    <td style={styles.tabletleft}>{reportmskresponse.pullup_remarks}</td>
                                                    </tr>  
                                                    <tr>                                          
                                                    <td style={styles.tabtrtd20}>Push Up</td>
                                                    <td style={styles.tabtrtd10}>{reportmskresponse.pushup_score}</td>
                                                    <td style={styles.tabletleft}>{reportmskresponse.pushup_remarks}</td>
                                                    </tr> 
                                                    <tr>                                          
                                                    <td style={styles.tabtrtd20}>Plank</td>
                                                    <td style={styles.tabtrtd10}>{reportmskresponse.plank_score}</td>
                                                    <td style={styles.tabletleft}>{reportmskresponse.plank_remarks}</td>
                                                    </tr> 
                                                    <tr>                                          
                                                    <td style={styles.tabtrtd20}>Medicine Ball Rotational Throw</td>
                                                    <td style={styles.tabtrtd10}>{reportmskresponse.medicineball_score}</td>
                                                    <td style={styles.tabletleft}>{reportmskresponse.medicineball_remarks}</td>
                                                    </tr>   
                                                </tbody>
                                            </table>  

                                            <table className="table align-items-center table-flush" style={styles.table}>
                                                <tbody>
                                                    <tr>
                                                    <td style={styles.tablehead}>IMPRESSION</td>
                                                    <td style={styles.tablehead}>APPROACH</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tabletleft}> {reportmskresponse.movementpattern_impression}</td>
                                                        <td style={styles.tabletleft}> {reportmskresponse.movementpattern_approach}</td>
                                                    </tr>
                                                </tbody>
                                            </table> 
                                        </div>
                                    </div>
                                    <ReportFooter /> 
                                </div>
                            </RctCollapsibleCard>                
                            <RctCollapsibleCard fullBlock > 
                                <ReportHeader />
                                <div style={styles.rctcontent}>
                                    <ReportBGImage  data={"70%"}/>
                                    <div className="rct-block-content" style={{padding:"1.25rem 1.25rem"}}>
                                        <div className="row justify-content-center reportdiv">
                                            <div className="page-break"></div>
                                            <div className="col-md-12">
                                                <h3 className="text-center" style={styles.secondheading}> PERFORMANCE TEST </h3>
                                            </div>
                                            {reportmskresponse.onermtestcheck==1 ?
                                            (                                        
                                                <div className="col-md-12 clearfix">
                                                    <h3 className="text-center" style={styles.secondheading}> 1RM TEST  </h3>
                                                </div>
                                            ) : '' }
                                            {reportmskresponse.onermtestcheck==1 ?
                                            (
                                                <table className="table align-items-center table-flush" style={styles.table}>
                                                    <tbody>
                                                        <tr>                                          
                                                            <td style={styles.tableheadblue15}>Test </td>
                                                            <td style={styles.tableheadblue12}>1RM value (kg)</td>
                                                            <td style={styles.tableheadblue}>Remarks</td>
                                                        </tr>
                                                        <tr>     
                                                            <td style={styles.tabtrtd15}>1RM Clean</td>
                                                            <td style={styles.tabtrtd12}>{reportmskresponse.rmclean_value} </td>
                                                            <td style={styles.tabletleft}>{reportmskresponse.rmclean_remarks}</td>                                                        
                                                        </tr>
                                                        <tr>     
                                                            <td style={styles.tabtrtd15}>1RM Back Squat</td>  
                                                            <td style={styles.tabtrtd12}>{reportmskresponse.rmsquat_value} </td>
                                                            <td style={styles.tabletleft}>{reportmskresponse.rmsquat_remarks}</td>                                                        
                                                        </tr>
                                                        <tr>     
                                                            <td style={styles.tabtrtd15}>1RM Bench Press</td>
                                                            <td style={styles.tabtrtd12}>{reportmskresponse.rmpress_value} </td>
                                                            <td style={styles.tabletleft}>{reportmskresponse.rmpress_remarks}</td>                                                        
                                                        </tr>
                                                    </tbody>
                                                </table> 
                                                    
                                            ) : '' }

                                            {reportmskresponse.aerobicfitnesscheck==1 ?
                                            (
                                                    
                                                <div className="row">
                                                    <h3 className="text-center" style={styles.secondheading}> AEROBIC FITNESS TEST   </h3>
                                                </div>
                                            ) : '' }
                                            {reportmskresponse.aerobicfitnesscheck==1 ?
                                            (
                                                <table className="table align-items-center table-flush" style={styles.table}>
                                                    <tbody>
                                                        <tr>                                          
                                                            <td style={styles.tableheadblue20}>Test </td>
                                                            <td style={styles.tableheadblue10}>Time  </td>
                                                            <td style={styles.tableheadblue20}>VO<sup style={{top: "5px"}}>2</sup> max (ml|kg|min)</td>
                                                            <td style={styles.tableheadblue}>Remarks</td>
                                                        </tr>
                                                        <tr>     
                                                            <td style={styles.tabtrtd20}>2.4km Run Test</td>                                     
                                                            <td style={styles.tabtrtd10}>{reportmskresponse.aerobicfitness_time} </td>
                                                            <td style={styles.tabtrtd10}>{reportmskresponse.aerobicfitness_vo}</td>
                                                            <td style={styles.tabletleft}>{reportmskresponse.aerobicfitness_remarks}</td>                                                        
                                                        </tr>
                                                        
                                                    </tbody>
                                                </table> 
                                                    
                                            ) : '' }

                                            {reportmskresponse.lowerbodypowercheck==1 ?
                                            (
                                                    
                                                <div className="row">
                                                    <h3 className="text-center" style={styles.secondheading}> LOWER BODY POWER TEST  </h3>
                                                </div>
                                            ) : '' }
                                            {reportmskresponse.lowerbodypowercheck==1 ?
                                            (
                                                <table className="table align-items-center table-flush" style={styles.table}>
                                                    <tbody>
                                                        <tr>                                          
                                                            <td style={styles.tableheadblue20}>Test </td>
                                                            <td style={styles.tableheadblue10}>Result (cm)</td>
                                                            <td style={styles.tableheadblue}>Remarks</td>
                                                        </tr>
                                                        <tr>     
                                                            <td style={styles.tabtrtd20}>Vertical Jump </td> 
                                                            <td style={styles.tabtrtd10}>{reportmskresponse.lowerboay_result}</td>  
                                                            <td style={styles.tabletleft}>{reportmskresponse.lowerboay_remarks}</td>                                                        
                                                        </tr>                                            
                                                    </tbody>
                                                </table> 
                                                    
                                            ) : '' }
                                            {reportmskresponse.upperbodystrengthcheck==1 ?
                                            (
                                                    
                                                <div className="row">
                                                    <h3 className="text-center" style={styles.secondheading}> UPPER BODY STRENGTH TEST  </h3>
                                                </div>
                                            ) : '' }
                                            {reportmskresponse.upperbodystrengthcheck==1 ?
                                            (
                                                <table className="table align-items-center table-flush" style={styles.table}>
                                                    <tbody>
                                                        <tr>                                          
                                                            <td style={styles.tableheadblue20}>Test </td>
                                                            <td style={styles.tableheadblue10}>Result (no)</td>
                                                            <td style={styles.tableheadblue}>Remarks</td>
                                                        </tr>
                                                        <tr>     
                                                            <td style={styles.tabtrtd20}>Pull Up (maximum no) </td>                                     
                                                            <td style={styles.tabtrtd10}>{reportmskresponse.upperbodystrength_score} </td>
                                                            <td style={styles.tabletleft}>{reportmskresponse.upperbodystrength_remarks}</td>                                                      
                                                        </tr>                                            
                                                    </tbody>
                                                </table> 
                                                    
                                            ) : '' }
                                            {reportmskresponse.accelerationspeedcheck==1 ?
                                            (
                                                    
                                                <div className="row">
                                                    <h3 className="text-center" style={styles.secondheading}>ACCELERATION SPEED </h3>
                                                </div>
                                            ) : '' }
                                            {reportmskresponse.accelerationspeedcheck==1 ?
                                            (
                                                <table className="table align-items-center table-flush" style={styles.table}>
                                                    <tbody>
                                                        <tr>                                          
                                                            <td style={styles.tableheadblue20}>Test </td>
                                                            <td style={styles.tableheadblue10}>Result (sec)</td>
                                                            <td style={styles.tableheadblue}>Remarks</td>
                                                        </tr>
                                                        <tr>     
                                                            <td style={styles.tabtrtd20}>20m Sprint Speed</td> 
                                                            <td style={styles.tabtrtd10}>{reportmskresponse.acceleration_result}</td>  
                                                            <td style={styles.tabletleft}>{reportmskresponse.acceleration_remarks}</td>                                                        
                                                        </tr>                                            
                                                    </tbody>
                                                </table> 
                                                    
                                            ) : '' }
                                            {reportmskresponse.coreendurancecheck==1 ?
                                            (
                                                    
                                                <div className="row"> 
                                                    <h3 className="text-center" style={styles.secondheading}>CORE ENDURANCE TEST </h3>
                                                </div>
                                            ) : '' }
                                            {reportmskresponse.coreendurancecheck==1 ?
                                            (
                                                <table className="table align-items-center table-flush" style={styles.table}>
                                                    <tbody>
                                                        <tr>                                          
                                                            <td style={styles.tableheadblue20}>Test</td>
                                                            <td style={styles.tableheadblue10}>Result (sec)</td>
                                                            <td style={styles.tableheadblue}>Remarks</td>
                                                        </tr>
                                                        <tr>     
                                                            <td style={styles.tabtrtd20}>Plank (maximum time) </td>                                     
                                                            <td style={styles.tabtrtd10}>{reportmskresponse.coreendurance_score} </td>
                                                            <td style={styles.tabletleft}>{reportmskresponse.coreendurance_remarks}</td>                                                      
                                                        </tr>                                            
                                                    </tbody>
                                                </table> 
                                                    
                                            ) : '' }
                                            <div className="row">
                                                    <h3 className="text-center" style={styles.secondheading}>KEY PERFORMANCE INDICATORS</h3>
                                            </div>
                                            <table className="table align-items-center table-flush" style={styles.table}>
                                                <tbody>
                                                    <tr>                                          
                                                        <td style={styles.tableheadblue}>Club Head Speed (miles/hr) </td>
                                                        <td style={styles.tableheadblue}>Driver Carry Distance (yards)</td>
                                                    </tr>
                                                    <tr>                                  
                                                        <td style={styles.tabletrtd}>{reportmskresponse.clubhd_box} </td>
                                                        <td style={styles.tabletrtd}>{reportmskresponse.drivercarry_distance}</td>                                                      
                                                    </tr>                                            
                                                </tbody>
                                            </table>
                                            
                                            <div className="row">
                                                <h3 className="text-center" style={styles.secondheading}>PLAN OF ACTION</h3>
                                            </div>
                                            <table className="table align-items-center table-flush" style={styles.table}>
                                                <tbody>
                                                    <tr>                                          
                                                        <td rowSpan="2" style={styles.tableheadblue}>IMPRESSION  </td>
                                                        <td colSpan="2" style={styles.tableheadblue}>Goal  </td>
                                                        <td rowSpan="2"style={styles.tableheadblue}>APPROACH </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tableheadblue}>Short Term Goals</td>
                                                        <td style={styles.tableheadblue}>Long Term Goals</td>
                                                    </tr> 
                                                    <tr>                                  
                                                        <td rowSpan="6" style={styles.tabletleft}>{reportmskresponse.clubhd_impression} </td>
                                                        <td rowSpan="6" style={styles.tabletleft}>{reportmskresponse.clubhdshrtgoal1}</td> 
                                                        <td rowSpan="6" style={styles.tabletleft}>{reportmskresponse.clubhdlonggoal1}</td>   
                                                        <td rowSpan="6" style={styles.tabletleft}>{reportmskresponse.clubhd_approach}</td>                                                      
                                                    </tr>                           
                                                </tbody>
                                            </table>   
                                        </div>
                                    </div>
                                    <ReportFooter /> 
                                </div>
                            </RctCollapsibleCard>    
                            </>       
                            ):''}

                        
                    </div>        

                } 
                {this.state.errordiv &&
                    <div className="col-sm-12 col-md-8">
                        <h4 style={styles.errmessage}> No Record Found </h4>
                    </div>
                }
                </div> 
       )
    }
 }


const mapStateToProps = ({mskassessment}) => {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
	const { reportmskresponse, reportDates, postureabbreivation, loading } = mskassessment;
	return {reportmskresponse, reportDates, postureabbreivation, loading};
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
}

export default connect(mapStateToProps, {    
    getMskReport,
    fetchPostureList,
    getMskReportDate
})(mskreport); 